import Icon from '@atoms/Icon/Icon';
import Text from '@atoms/Text/Text';
import classNames from 'classnames';

interface Props {
  readonly title: string;
  readonly subText: string;
  readonly isPrimary?: boolean;
}

const WishlistEmptyState = ({ title, subText, isPrimary = true }: Props) => (
  <div className=" tw-text-black">
    <div
      className={classNames(
        {
          'tw-border tw-border-dashed tw-border-grey-30': !isPrimary,
        },
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-xs tw-px-xs tw-py-md',
      )}
    >
      <Icon name="empty-wishlist" size="6rem" />
      <div className="xl:max-w-[50%] tw-mx-auto tw-flex tw-flex-col tw-gap-xxs tw-text-center">
        <Text variant={isPrimary ? 'heading-24-light' : 'heading-21-light'}>
          {title}
        </Text>
        <Text variant="body" className="tw-text-grey-80">
          {subText}
        </Text>
      </div>
    </div>
  </div>
);

export default WishlistEmptyState;
